const updateCartCount = (quantity) => {
  if (window.Firmhouse) {
    const cartCountWrapper = document.querySelectorAll('[data-cart-icon]');

    cartCountWrapper.forEach((wrapper) => {
      let cartCountAmount = wrapper.querySelector('[data-cart-count]');

      if (quantity > 0) {
        cartCountAmount.innerHTML = quantity;
      }
      else {
        cartCountAmount.innerHTML = '';
      }
    });
  }
}

window.addEventListener("firmhouse:cart_updated", (e) => {
  // const numberOfProducts = e.detail.orderedProducts.length;
  const totalQuantity = e.detail.orderedProducts.reduce((sum, orderedProduct) => sum + orderedProduct.quantity, 0);

  updateCartCount(totalQuantity);
});

// set cart amount on page load
window.addEventListener("firmhouse:ready", (e) => {
  window.Firmhouse.currentCart()

  const addToCartBtns = document.querySelectorAll('[data-add-to-cart-x]');
  addToCartBtns.forEach((addToCartBtn) => {
    addToCartBtn.addEventListener('click', (e) => onClickAddToCart(e));
  });
});

// Custom added code for Firmhouse
window.setTimeout(() => {
  // Catch the form submits
  const productForms = document.querySelectorAll('[data-firmhouse-target]');
  productForms.forEach(firmhouseForm => {

    firmhouseForm.addEventListener("submit", (e) => {
      console.log('SUBMIT')
      e.preventDefault();
      e.stopPropagation();
      onClickAddToCart(e, firmhouseForm);
    });
  });
}, 500);

const onClickAddToCart = async (e, firmhouseForm) => {
  e.stopPropagation();
  e.preventDefault();

  let variantID = '';
  const variants = firmhouseForm.querySelectorAll('[name="time"]');
  variants.forEach((variant) => {
    if (variant.checked) {
      variantID = variant.dataset.variantId;
    }
  })

  if (variantID) {
    await window.Firmhouse.addToCart({shopifyVariantId: variantID });
  }

  window.Firmhouse.showCart();
};